import React from 'react';
import { theme } from '~/theme';
import {
    StyledBanner,
    StyledCheckoutBannerText,
    StyledContent,
    StyledDesktopNav,
    StyledDivBanner,
    StyledIconButtonCheckoutBannerDesktop,
    StyledLogo,
    StyledLogoContainer,
    StyledMainNavigation,
} from './styled';
import ChevronLeft from '~/icons/chevron-left.svg';
import { CheckoutSteps } from '~/shared/components/CheckoutSteps';
import Flex from '~/shared/components/Flex';
import { CheckoutBanner } from '../CheckoutBanner';
import { useTranslation } from '~/shared/utils/translation';
import { useCheckoutState } from '../../hooks/useCheckoutState';
import { ProgressLoader } from '~/features/navigation/components/N20MainMenu/styled';
import { Link } from '~/shared/components';
type Props = {
    textColor?: string;
    bannerText?: string;
    bannerValue?: string;
    isUserLoggedIn?: boolean;
    activeDelivery?: number;
    steps: string[];
};
export const CheckoutHeader = (props: Props) => {
    const { translate } = useTranslation();
    const { currentStep, goBack } = useCheckoutState();
    const { steps, textColor, bannerText, isUserLoggedIn } = props;

    const previousIndex = () => {
        if (currentStep === 0) {
            return translate('header.basket');
        }

        return steps[currentStep - 1];
    };

    return (
        <StyledMainNavigation hidden={false}>
            <StyledContent>
                <StyledCheckoutBannerText textColor={textColor as string} onClick={goBack}>
                    <StyledIconButtonCheckoutBannerDesktop
                        aria-label="Gå tilbage til din kurv"
                        children={<ChevronLeft />}
                    />
                    {currentStep === 0 ? translate('header.basket') : steps[currentStep - 1]}
                </StyledCheckoutBannerText>

                <Flex
                    justifyContent="center"
                    alignItems="center"
                    style={{ flexBasis: 0, flexGrow: 1 }}
                >
                    <StyledLogoContainer>
                        <Link href="/">
                            <StyledLogo />
                        </Link>
                    </StyledLogoContainer>
                </Flex>
                <StyledDesktopNav>
                    <CheckoutSteps
                        activeIndex={currentStep}
                        steps={steps}
                        textColor={theme.colors.white}
                    />
                </StyledDesktopNav>
            </StyledContent>
            <StyledDivBanner>
                <StyledBanner
                    textColor={theme.colors.black}
                    backGroundColor={theme.colors.headerColor}
                    childComponent={
                        <>
                            <CheckoutBanner
                                textColor={theme.colors.black}
                                bannerText={bannerText}
                                goBackText={previousIndex()}
                                onGoBackClick={goBack}
                                isUserLoggedIn={isUserLoggedIn}
                            />
                        </>
                    }
                />
            </StyledDivBanner>
            <ProgressLoader id="progress-loader" />
        </StyledMainNavigation>
    );
};
